import { Component } from '@angular/core';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { APIWebService } from '@shared/services/api-web.service';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'fc-mobile-navigation',
  templateUrl: './mobile-navigation.component.html',
  styleUrls: ['./mobile-navigation.component.css'],
})
export class MobileNavigationComponent {
  faLocationDot = faLocationDot;
  navs: any = [
    {
      name: 'Home',
      iconImage: '/assets/icons/home.svg',
      link: '/',
    },
    {
      name: 'Beautybook',
      iconImage: '/assets/icons/beauty.svg',
      link: '/list',
    },
    {
      name: 'Skinfit',
      iconImage: '/assets/icons/acne.svg',
      link: '/user/dashboard',
    },

    {
      name: 'Sale',
      iconImage: '/assets/icons/bag.svg',
      link: '/product',
      queryParams: { sale: true },
    },
    {
      name: 'Whatsapp',
      iconImage: '/assets/icons/whatsapp.svg',
      anchor: '',
    },
  ];
  isShowMobileNav = true;

  mobileLayoutConfig: any;
  constructor(
    private layoutService: LayoutService,
    private apiWebService: APIWebService
  ) {
    this.layoutService.mobileLayoutConfig$.subscribe((mobileLayoutConfig) => {
      this.mobileLayoutConfig = mobileLayoutConfig;
    });
    this.apiWebService.getLocalJsonChat().subscribe((data: any) => {
      let chat = data;
      if (chat)
        this.navs[4].anchor = `https://api.whatsapp.com/send?phone=${chat.whatsapp.number}&text=${chat.whatsapp.message}`;
    });
  }
}
